import { HTMLMotionProps, motion } from 'framer-motion';
import React, { FC, forwardRef } from 'react';
import { fadeInScaleY } from '@utils/animations';

type Props = HTMLMotionProps<'tr'> & { index: number | string };

export const AnimatedTr: FC<Props> = forwardRef<HTMLTableRowElement, Props>(({ index, children, ...rest }, ref) => {
  return (
    <motion.tr
      key={index}
      ref={ref}
      animate="displayed"
      exit="hidden"
      initial="hidden"
      style={{ originY: 0 }}
      variants={fadeInScaleY}
      {...rest}
    >
      {children}
    </motion.tr>
  );
});
